import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import BarChartCustom from "../../../../../components/shared/chart/BarChartCustom";
import PieChartCustom from "../../../../../components/shared/chart/PieChartCustom";

const SmsMonitoringCharts = ({ summary }) => {
  if (!summary) return null;

  const dailyData = (summary.smsCountByDay || []).map((item) => ({
    name: item.date,
    value: item.count,
  }));

  const costData = (summary.costByDay || []).map((item) => ({
    name: item.date,
    value: item.cost,
  }));

  const successFailedData = [
    { name: "موفق", value: summary.successfulSms || 0 },
    { name: "ناموفق", value: summary.failedSms || 0 },
    { name: "در انتظار", value: summary.pendingSms || 0 },
  ].filter((x) => x.value > 0);

  const typeData = Object.entries(summary.smsByType || {}).map(([name, value]) => ({
    name,
    value,
  }));

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} md={6}>
        <Card variant="outlined">
          <CardHeader title="تعداد پیامک — ۷ روز اخیر" />
          <CardContent>
            <BarChartCustom data={dailyData} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card variant="outlined">
          <CardHeader title="هزینه روزانه — ۷ روز اخیر" />
          <CardContent>
            <BarChartCustom data={costData} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card variant="outlined">
          <CardHeader title="موفق در برابر ناموفق" />
          <CardContent>
            <PieChartCustom data={successFailedData} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card variant="outlined">
          <CardHeader title="توزیع نوع پیامک" />
          <CardContent>
            <PieChartCustom data={typeData} />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SmsMonitoringCharts;
